import { gsap } from 'gsap';

export class AnimationChain {
	constructor() {
		this.timeline = gsap.timeline();
    }

	fadeInFrom(elem, duration = 0.5, ease = "power2.inout") {
		this.timeline.fromTo(elem, {autoAlpha: 0}, {autoAlpha: 1, duration: duration, ease: ease})
		return this;
	}

	fadeIn(elem, duration = 0.5, ease = "power2.inout") {
		this.timeline.to(elem, {autoAlpha: 1, duration: duration, ease: ease})
		return this;
	}

	fadeOutFrom(elem, duration = 0.5, ease = "power2.inout") {
		this.timeline.fromTo(elem, {autoAlpha: 1}, {autoAlpha: 0, duration: duration, ease: ease})
		return this;
	}

	fadeOut(elem, duration = 0.5, ease = "power2.inout") {
		this.timeline.to(elem, {autoAlpha: 0, duration: duration, ease: ease})
		return this;
	}

	fadeInUp(elem, y = 100, duration = 0.5, ease = "power2.inout") {
		this.timeline.fromTo(elem, {autoAlpha: 0, y: y}, {autoAlpha: 1, y: 0, duration: duration, ease: ease})
		return this;
	}

	scaleDown(elem, scale = 1.2, duration = 0.5, ease = "power2.inout") {
		this.timeline.fromTo(elem, {scale: scale}, {scale: 1, duration: duration, ease: ease})
		return this;
	}
}